<template id="baseButton">
  <button class="bouton-fleche" type="button" aria-label="button navigation">
    <img alt="Bouton de navigation" :src="'img/chevron-'+text+'.svg'">
  </button>
</template>

<script>
export default {
  name:"PaginationBoutonFleche",
  props: ['text']
}
</script>